export default __webpack_public_path__ + "94b3f09bcdcd52f09a07822767f3789a.png";